/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataTakerStaffDataModel } from '../../models/data-taker-staff-data-model';

export interface GetDataTakerStaffsForBehaviorID$Params {
  behaviorID?: number;
}

export function GetDataTakerStaffsForBehaviorID(http: HttpClient, rootUrl: string, params?: GetDataTakerStaffsForBehaviorID$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DataTakerStaffDataModel>>> {
  const rb = new RequestBuilder(rootUrl, GetDataTakerStaffsForBehaviorID.PATH, 'get');
  if (params) {
    rb.query('behaviorID', params.behaviorID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DataTakerStaffDataModel>>;
    })
  );
}

GetDataTakerStaffsForBehaviorID.PATH = '/api/Graph/GetDataTakerStaffsForBehaviorID';
